import FlowersScene from "./FlowersScene";

export default function Flower() {
  return <>
    <div className="mt-100 md:mt-0">

    <div className="flex md:justify-between items-end justify-center ">
      <FlowersScene className="absolute md:relative" width={350} height={350} />
      <FlowersScene className="absolute md:relative " width={400} height={400}  />
    </div>
    </div>
  </>
}
